module.exports = __webpack_public_path__ + "assets/img/season-code-03-a43a4f01.png";